
// 自动导入所有 SVG 图标
const svgRequire = require.context('./svg', false, /\.svg$/)
svgRequire.keys().forEach(svgRequire) 